import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override serialize(tree: UrlTree): string {
    return this._withTrailingSlash(super.serialize(tree));
  }

  private _withTrailingSlash(url: string): string {
    if (url === '/') return url;

    const splitOnQuery = url.indexOf('?') > -1 ? '?' : (url.indexOf('#') > -1 ? '#' : '');
    const pathArr = splitOnQuery ? url.split(splitOnQuery) : [url];
    let path = pathArr[0];

    if (!path.endsWith('/') && !path.split('/').pop()?.includes('.')) {
      path += '/';
    }

    pathArr[0] = path;
    return splitOnQuery ? pathArr.join(splitOnQuery) : pathArr[0];
  }
}
